import {useEffect, useReducer, useState } from "react";
const ACTIONS = {
    CALL_API: 'call-api',
    SUCCESS: 'success',
    ERROR: 'error',
    SET_INITIAL_DATA: 'set-data',
    TEXT_CHANGE: 'text-change',
    TEXT_SET_ERRORS: 'text-set-errors',
    TEXT_REMOVE_ERRORS: 'text-remove-errors',
    RADIO_CHANGE: 'radio-change',
    RADIO_SET_ERRORS: 'radio-set-errors',
    RADIO_REMOVE_ERRORS: 'radio-remove-errors',
    SELECT_CHANGE: 'select-change',
    SELECT_SET_ERRORS: 'select-set-errors',
    SELECT_REMOVE_ERRORS: 'select-remove-errors',
    CHECK_CHANGE: 'check-change',
    CHECK_SET_ERRORS: 'check-set-errors',
    CHECK_REMOVE_ERRORS: 'check-remove-errors',
    DATE_CHANGE: 'date-change',
    DATE_SET_ERRORS: 'date-set-errors',
    DATE_REMOVE_ERRORS: 'date-remove-errors',
    TEXT_AREA_CHANGE: 'text-area-change',
    FILE_CHANGE: 'file-change',
};

const formInfoReducer = (state, action) => {
    //console.log("dispatch triggered", state, action);

    switch (action.type) {
        case ACTIONS.SET_INITIAL_DATA: {
            return {
                ...state,
                data: action.data,
                loading: action.loading
            };
        }
        case ACTIONS.TEXT_CHANGE: {
            //console.log("state-TEXTCHANGE");
            //console.log(state);
            //console.log(state.data[action.name]);
            const path = state.data[action.name];
            return {
                ...state,
                data: {
                    ...state.data,
                    [action.name]: {
                        ...state.data[action.name],
                        value: action.value,
                        validation:{
                            ...path.validation,
                            isInvalid: false,//isInvalidFunc(path.validation.required,action.value),
                            errors: []
                        }
                    }
                        
                }
            };
        }
        
        case ACTIONS.DATE_CHANGE: {
            //console.log("state-DATECHANGE");
            //console.log(state);
            //console.log(state.data[action.name]);
            const path = state.data[action.name];
            return {
                ...state,
                data: {
                    ...state.data,
                    [action.name]: {
                        ...state.data[action.name],
                        value: action.value,
                        validation:{
                            ...path.validation,
                            isInvalid: false,//isInvalidFunc(path.validation.required,action.value),
                            errors: []
                        }
                    }
                        
                }
            };
        }
        case ACTIONS.RADIO_CHANGE: {
            //console.log("state");
            //console.log(state);

            const path = state.data[action.name];
            //console.log(path.radioButtons);
            //console.log(action.name);

            return {
                ...state,
                data: {
                    ...state.data,
                    [action.name]: {
                        ...path,
                        radioButtons: 
                            path.radioButtons.map((button) => {
                                //console.log(button.value + " " + action.value);
                                button.isChecked = false;
                                if (button.value == action.value) {
                                    //console.log("change");
                                    button.isChecked = true;
                                }

                                //console.log(button);
                                return button;
                            }),
                        validation:{
                            ...path.validation,
                            isInvalid: false,//isInvalidFunc(path.validation.required,action.value),
                            errors: []
                        }

                    }
                }
            };
        }
        case ACTIONS.SELECT_CHANGE: {
            //console.log("state");
            //console.log(state);

            const path = state.data[action.name];
            //console.log(path.options);
            //console.log(action.name);

            return {
                ...state,
                data: {
                    ...state.data,
                    [action.name]: {
                        ...path,
                        value: action.value,
                        options: 
                            path.options.map((option) => {
                                //console.log(option.value + " " + action.value);
                                if (option.value == action.value) {
                                    //console.log("change");
                                    option.isSelected = true;
                                }
                                else{
                                    option.isSelected = false;
                                }

                                return option;
                                
                            }),
                        validation:{
                            ...path.validation,
                            isInvalid: false,//isInvalidFunc(path.validation.required,action.value),
                            errors: []
                        }
                    }
                }
            };
        }
        case ACTIONS.CHECK_CHANGE: {
            //console.log("state");
            //console.log(state);

            const path = state.data[action.name];
            //console.log(path.checkBoxes);
            //console.log(action.name);

            return {
                ...state,
                data: {
                    ...state.data,
                    [action.name]: {
                        ...path,
                        checkBoxes: 
                            path.checkBoxes.map((option) => {
                                //console.log(option.isChecked + " " + action.isChecked);
                                option.isChecked=action.isChecked;
                                option.value=action.isChecked;
                                //console.log(option);
                                return option;
                            }),
                        validation:{
                            ...path.validation,
                            isInvalid: false,//isInvalidFunc(path.validation.required,action.value),
                            errors: []
                        }

                    }
                }
            };
        }
        case ACTIONS.TEXT_SET_ERRORS: {
            //console.log("state");
            //console.log(state);

            const path = state.data[action.name];
            return {
                ...state,
                data: {
                    ...state.data,
                    [action.name]: {
                        ...state.data[action.name],
                        validation:{
                            ...path.validation,
                            isInvalid: action.errors != null ? true : false,//isInvalidFunc(path.validation.required,action.value),
                            errors: action.errors
                        }
                    } 
                }
            };
        }
        case ACTIONS.TEXT_REMOVE_ERRORS: {
            const path = state.data[action.name];
            return {
                ...state,
                data: {
                    ...state.data,
                    [action.name]: {
                        ...state.data[action.name],
                        validation:{
                            ...path.validation,
                            isInvalid: false,
                            errors: []
                        }
                    } 
                }
            };
        }

        case ACTIONS.DATE_SET_ERRORS: {
            //console.log("state");
            //console.log(state);

            const path = state.data[action.name];
            return {
                ...state,
                data: {
                    ...state.data,
                    [action.name]: {
                        ...state.data[action.name],
                        validation:{
                            ...path.validation,
                            isInvalid: action.errors != null ? true : false,//isInvalidFunc(path.validation.required,action.value),
                            errors: action.errors
                        }
                    } 
                }
            };
        }
        case ACTIONS.DATE_REMOVE_ERRORS: {
            const path = state.data[action.name];
            return {
                ...state,
                data: {
                    ...state.data,
                    [action.name]: {
                        ...state.data[action.name],
                        validation:{
                            ...path.validation,
                            isInvalid: false,
                            errors: []
                        }
                    } 
                }
            };
        }

        case ACTIONS.RADIO_SET_ERRORS: {
            //console.log("state");
            //console.log(state);

            const path = state.data[action.name];
            //console.log(path.radioButtons);
            //console.log(action.name);

            return {
                ...state,
                data: {
                    ...state.data,
                    [action.name]: {
                        ...path,
                        validation:{
                            ...path.validation,
                            isInvalid: action.errors != null ? true : false,//isInvalidFunc(path.validation.required,action.value),
                            errors: action.errors
                        }

                    }
                }
            };
        }
        case ACTIONS.RADIO_REMOVE_ERRORS: {
            //console.log("state");
            //console.log(state);

            const path = state.data[action.name];
            //console.log(path.radioButtons);
            //console.log(action.name);

            return {
                ...state,
                data: {
                    ...state.data,
                    [action.name]: {
                        ...path,
                        validation:{
                            ...path.validation,
                            isInvalid: false,
                            errors: []
                        }

                    }
                }
            };
        }
        
        case ACTIONS.SELECT_SET_ERRORS: {
            //console.log("state");
            //console.log(state);

            const path = state.data[action.name];
            //console.log(path.options);
            //console.log(action.name);

            return {
                ...state,
                data: {
                    ...state.data,
                    [action.name]: {
                        ...path,
                        validation:{
                            ...path.validation,
                            isInvalid: action.errors != null ? true : false,//isInvalidFunc(path.validation.required,action.value),
                            errors: action.errors
                        }
                    }
                }
            };
        }

        case ACTIONS.SELECT_REMOVE_ERRORS: {
            //console.log("state");
            //console.log(state);

            const path = state.data[action.name];
            //console.log(path.options);
            //console.log(action.name);

            return {
                ...state,
                data: {
                    ...state.data,
                    [action.name]: {
                        ...path,
                        validation:{
                            ...path.validation,
                            isInvalid: false,
                            errors: []
                        }
                    }
                }
            };
        }

        case ACTIONS.CHECK_SET_ERRORS: {
            //console.log("state");
            //console.log(state);

            const path = state.data[action.name];
            //console.log(path.checkBoxes);
            //console.log(action.name);

            return {
                ...state,
                data: {
                    ...state.data,
                    [action.name]: {
                        ...path,
                        
                        validation:{
                            ...path.validation,
                            isInvalid: action.errors != null ? true : false,//isInvalidFunc(path.validation.required,action.value),
                            errors: action.errors
                        }

                    }
                }
            };
        }
        case ACTIONS.CHECK_REMOVE_ERRORS: {
            //console.log("state");
            //console.log(state);

            const path = state.data[action.name];
            //console.log(path.checkBoxes);
            //console.log(action.name);

            return {
                ...state,
                data: {
                    ...state.data,
                    [action.name]: {
                        ...path,
                        
                        validation:{
                            ...path.validation,
                            isInvalid: false,
                            errors: []
                        }

                    }
                }
            };
        }
    }
}







export {ACTIONS, formInfoReducer};